import { useEffect, useMemo, useState } from 'react';
import { AutocompleteOption } from '../models/autocompleteOption';
import { getEmployeeProjects } from '../services/api/employeeServices';
import { generateProjectLabel } from '../services/projectService';

interface UseActivityProjectListReturn {
  projects: AutocompleteOption[];
  isLoading: boolean;
}

export function useEmployeeProjectList(
  idEmployee: string,
  searchQuery = ''
): UseActivityProjectListReturn {
  const [projectOptions, setProjectOptions] = useState<AutocompleteOption[]>(
    []
  );
  const [isLoading, setIsLoading] = useState(false);

  const lowercaseSearchQuery = searchQuery.toLowerCase();

  useEffect(() => {
    if (!idEmployee) {
      return;
    }

    setIsLoading(true);
    getEmployeeProjects({
      internalId: idEmployee,
    })
      .then((resp) => {
        setProjectOptions(
          resp.items.map((project) => ({
            id: project.id,
            label: generateProjectLabel(project.name, project.code),
            isAMS: project.isAMS,
          }))
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [idEmployee]);

  const projects = useMemo(() => {
    return projectOptions.filter((project) =>
      project.label.toLowerCase().includes(lowercaseSearchQuery)
    );
  }, [lowercaseSearchQuery, projectOptions]);

  return { projects, isLoading };
}
